import { AxiosInstance } from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  attemptShowErrorsInSnackbar,
  showSnackbarType,
  useSnackbarActionContext,
} from "../../../context/SnackbarContext";
import { PageHeader } from "@velocity-ehs/component-library";
import { ssoOutgoingItemQuery } from "../../supportFunctions/graphql/SSOOutgoingQueries";
import { SPMetadata } from "./SPMetadata";
import SPMetadataForm, { Mode } from "./SPMetadataForm";
import { useTranslation } from "react-i18next";
import UsersService from "@velocity-ehs/user-utils-module";
import { useFlags } from "launchdarkly-react-client-sdk";
import VerticalTabs from "../../sharedComponents/VerticalTabs";
import GatewayService from "../../../services/GatewayService";

const EditMetadata: React.FC = () => {
  const { productChangeTracking } = useFlags();

  const { showSnackbar } = useSnackbarActionContext();
  const { id } = useParams<{ id: string }>();
  const [metadata, setMetadata] = useState<any>();
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    getMetadata({
      graphQlAxios: GatewayService.api,
      customerId: UsersService.customer?.id,
      metadataId: id,
      setMetadata: setMetadata,
      setIsLoading: setIsLoading,
      showSnackbar: showSnackbar,
    });
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <PageHeader
        title={metadata ? metadata.ribbonDesc : "..."}
        navigationTree={[
          { text: `Accelerate ${t("universal_Home")}`, href: "/" },
          {
            text: t("universal_Application_Config"),
            href: "/applicationConfig",
          },
          { text: t("action_edit"), href: "" },
        ]}
      />
      <VerticalTabs
        includeChangeTracking={productChangeTracking}
        targetIdentifierType="AppConfig"
        tabs={[
          {
            title: t("application_Config_Application_Config_Details_Text"),
            content: (
              <SPMetadataForm
                mode={Mode.Edit}
                metaData={metadata}
                isLoading={isLoading}
              />
            ),
          },
        ]}
      />
    </>
  );
};

export type SetMetaData = (newData: SPMetadata) => void;

export type GetMetadataProps = {
  graphQlAxios: AxiosInstance;
  customerId: string;
  setMetadata: SetMetaData;
  setIsLoading: (val: boolean) => void;
  metadataId: string;
  showSnackbar: showSnackbarType | undefined;
};
export const getMetadata = ({
  graphQlAxios,
  customerId,
  setMetadata,
  setIsLoading,
  metadataId,
  showSnackbar,
}: GetMetadataProps) => {
  setIsLoading(true);
  graphQlAxios
    .post("", ssoOutgoingItemQuery(metadataId))
    .then((response: any) => {
      setIsLoading(false);
      setSPMetadataItems({
        item: response.data.data.SSOOutgoing,
        currentCustomerId: customerId,
        setMetadata: setMetadata,
      });
    })
    .catch((error: any) => {
      /* eslint-disable-next-line no-console */
      console.log(error);
      attemptShowErrorsInSnackbar(showSnackbar, error);
      setIsLoading(false);
    });
};

export type SetSPMetadataItemsProps = {
  item: any;
  currentCustomerId: string;
  setMetadata: SetMetaData;
};
export const setSPMetadataItems = ({
  item,
  currentCustomerId,
  setMetadata,
}: SetSPMetadataItemsProps) => {
  const ssoOutgoingObject: SPMetadata = {
    ...item,
    forCurrentCustomer: item.customer?.id === currentCustomerId,
    customer: item.customer?.id,
  };
  setMetadata(ssoOutgoingObject);
};

export default EditMetadata;
